/* eslint-disable */
import Excel from 'exceljs';
import { saveAs } from 'file-saver';

export function convertArrayOfObjectsToCSV(args) {
  var result, ctr, keys, columnDelimiter, lineDelimiter, data, headers;

  data = args.data || null;
  if (data == null || !data.length) {
    return null;
  }

  columnDelimiter = args.columnDelimiter || ";";
  lineDelimiter = args.lineDelimiter || "\n";

  keys = Object.keys(data[0]).filter(key => key !== "id");

  result = "";
  // result += headers.join(columnDelimiter);
  // result += lineDelimiter;

  headers = args.headers || null;
  if (headers == null || !headers.length) {
    headers = keys;

    result += headers.join(columnDelimiter);
    result += lineDelimiter;
  } else {
    headers.forEach(function(item) {
      ctr = 0;
      keys.forEach(function(key) {
        if (ctr > 0) result += columnDelimiter;

        result += item[key];
        ctr++;
      });
      result += lineDelimiter;
    });
  }

  data.forEach(function(item) {
    ctr = 0;
    keys.forEach(function(key) {
      if (ctr > 0) result += columnDelimiter;

      result += item[key] ? item[key].toString().replace(/"|&quot;|&amp;/g, char => {return key[char] || ''}) : 'null';
      ctr++;
    });
    result += lineDelimiter;
  });

  return result;
}

export function convertArraysToCSV(args) {
  var result, keys, columnDelimiter, lineDelimiter, data;

  data = args.rows || null;
  if (data == null || !data.length) {
    return null;
  }

  columnDelimiter = args.columnDelimiter || ";";
  lineDelimiter = args.lineDelimiter || "\n";

  keys = args.headers;

  result = "";
  result += keys.join(columnDelimiter);
  result += lineDelimiter;

  data.map(item => result + item.join(columnDelimiter) + lineDelimiter);

  return result;
}

export function downloadBrowserCSV(args) {
  var filename, link;

  var csv = convertArrayOfObjectsToCSV({
    data: args.data,
    headers: args.headers,
    columnDelimiter: args.columnDelimiter,
    lineDelimiter: args.lineDelimiter
  });
  if (csv == null) return;

  var dumpd = csv;

  filename = args.filename || "export.csv";

  // if (!csv.match(/^data:text\/csv/i)) {
  //   csv = "data:text/csv;charset=utf-8,\ufeff" + csv;
  // }
  // data = encodeURI(csv);

  var csvData = new Blob(["\ufeff" + dumpd], {
    type: "text/csv;charset=utf-8;"
  });
  var csvUrl = URL.createObjectURL(csvData);

  link = document.createElement("a");
  link.setAttribute("href", csvUrl);
  link.setAttribute("download", filename);
  link.click();
}

export async function downloadXLSX(props) {
  // settings
  const workbook = new Excel.Workbook();
  workbook.creator = 'BI';
  workbook.lastModifiedBy = 'BI';
  workbook.created = new Date()
  workbook.modified = new Date()
  workbook.lastPrinted = new Date()

  workbook.views = [{ firstSheet: 0, activeTab: 1, visibility: 'visible' }]
  // set
  const sheet = workbook.addWorksheet('Raport');

  // header columns
  const arrHeader = [];
  props.headers.flat().map((item, index) => {
    arrHeader.push({
      header: item,
      width: 20,
      key: `bi-${index}`
    })
  })

  // header settings
  sheet.columns = arrHeader
  sheet.getRow(1).height = 35
  sheet.getRow(1).font = {bold: true, size: 14},
  sheet.getRow(1).alignment = { vertical: 'middle', horizontal: 'center', wrapText: true }
  sheet.getRow(1).fill = { type: 'pattern', pattern:'solid', fgColor:{argb:'D9D9D9'}}
  sheet.getRow(1).border = {top: {style:'thin', color: {argb:'2727271'}}, left: {style:'thin', color: {argb:'2727271'}}, bottom: {style:'thin', color: {argb:'2727271'}}, right: {style:'thin', color: {argb:'2727271'}}}

  let i = 1;
  props.data.map((item, index) => {
    const data = []
    item.map(x => {
      data.push(x)
    })
    sheet.addRow(data);
    const row = sheet.getRow(i+1)
    row.height = 20
    row.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true }
    row.font = {size: 11}
    i++;
  })

  workbook.xlsx.writeBuffer().then(buffer => {
    saveAs(new Blob([buffer],{type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8"}), props.filename)
  })
  // const blob = new Blob([report], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
}



// WEBPACK FOOTER //
// ./src/lib/download.js